import StoreAPI from '../StoreAPI';
import { M_SECONDS_POOLING_OPERATOR_INTERVAL_DATA } from '../Store.constants';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { DevicesStoreInfoResponse } from '../StoreService.model';
import { ComposableDevice } from '../../group/group.model';
import useDevicesWithComposableDevice from './useDevicesWithComposableDevice';
import orComparator from '../../../shared/util/lodash/merge/orComparator';
import _ from 'lodash';

type Options = Parameters<UseQuerySubscription<any>>[1];
export type ComposableDevicesStoreInfoResponse = {
  composableDevice?: ComposableDevice;
} & DevicesStoreInfoResponse;
function useDevicesOperator(options: Options = {}) {
  const responseAPI = StoreAPI.useGetStoreInfoDetailsQuery(undefined, {
    pollingInterval: M_SECONDS_POOLING_OPERATOR_INTERVAL_DATA,
    ...options,
  });
  const { data: storeInfoDetails, ...rest } = responseAPI;

  const { devices = [], ...restDevices } = useDevicesWithComposableDevice(
    storeInfoDetails?.uuid ?? '',
    storeInfoDetails?.devices || []
  );

  return {
    devices,
    ..._.chain({ ...rest })
      .mergeWith(restDevices, orComparator)
      .value(),
  };
}

export default useDevicesOperator;
